/* eslint-disable sonarjs/no-use-of-empty-return-value */
/* eslint-disable sonarjs/cognitive-complexity */
import React, { useMemo, useRef, useState } from 'react';
import { Formik, FieldArray } from 'formik';
import { PropTypes } from 'prop-types';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Col, Row } from 'antd';
import { isEmpty } from 'lodash';
import { Form, Select, Radio } from 'formik-antd';
import { PoweroffOutlined, DeleteOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Box, FormInput, CustomInput, Button, Text } from 'atoms';
import { Debug } from './Debug';
import { updateClient } from 'store/clientSlice';
import { ACL, BoxMod, EditModeBtn, ImageView } from 'components/common';
// import { useQuery } from 'hooks';
import FilesUploadS3 from 'components/common/FilesUploadS3';
import {
	adhoc_approval_required_data,
	gstRegType,
	pdfimgfiletypetoShow,
	pdfimgformates,
	pinError,
} from 'utils';
import { ActionAddButton, CancelButton } from 'utils/commonStyled';
import { getPincodeList } from 'store/pageSlice';

function getBillingPreFilledData(formData) {
	console.log(formData);
	if (formData.length === 0) {
		/**
		 * On first time if not data available, add one row data
		 */
		return [getNewBillingRowData()];
	}
	/**
	 * If data already available create rows based on that
	 */
	return formData?.map((item) => ({
		id: Math.random(),
		...item,
	}));
}

function getNewBillingRowData() {
	return {
		id: Math.random(),
		address: undefined,
		pin_code: undefined,
		zone: undefined,
		state: undefined,
		city: undefined,
	};
}

export default function ClientAllSectionForm({
	isEditMode = false,
	formData = {},
	otherFormsData = {},
}) {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	// const [query] = useQuery();
	const [editMode, setEditMode] = useState(false);

	if (formData === undefined) {
		formData = {
			banking_info: {},
			billing_info: [],
			crf_filename: {},
			document_info: {},
			other_info: {},
			shipping_info: [],
		};
	}

	const FormSchema = useMemo(
		() =>
			Yup.object({
				adhoc_approval_required: Yup.boolean().label('Adhoc Approval').required(),
				acc_number: Yup.string()
					.min(6)
					.max(24)
					.label('Account Number')
					.matches(/^[0-9]*$/, 'Please enter valid Account Number'),
				ifsc_code: Yup.string()
					.min(11)
					.max(11)
					.label('IFSC Code')
					.matches(/^[a-zA-Z]{4}0[a-zA-Z0-9]{6}$/, 'Please enter valid IFSC ode'),
				bank_name: Yup.string()
					.min(4)
					.max(30)
					.label('Bank Name')
					.matches(/^[a-zA-Z ]*$/, 'Please enter valid Bank Name'),
				bank_city: Yup.string()
					.label('Bank City')
					.matches(/^[a-zA-Z ]*$/, 'Please enter valid City'),
				bank_branch: Yup.string()
					.min(5)
					.max(32)
					.label('Bank Branch')
					.matches(/^[a-zA-Z0-9 -.,&/()]*$/, 'Please enter valid Branch'),
				bank_doc: Yup.array().when(
					['acc_number', 'ifsc_code', 'bank_name', 'bank_city', 'bank_branch'],
					{
						is: (acc_number, ifsc_code, bank_name, bank_city, bank_branch) =>
							acc_number || ifsc_code || bank_name || bank_city || bank_branch,
						then: Yup.array().required(
							'Bank document is required when bank details are provided'
						),
						otherwise: Yup.array(),
					}
				),
				pan_number: Yup.string()
					.required()
					.min(10)
					.max(25)
					.label('Pan Number')
					.matches(/^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}/, 'Please enter valid Pan Number'),
				gst_reg_type: Yup.string().required().label('GSt reg type'),
				credit_amt: Yup.number().min(1).max(999999).label('Credit Amount'),
				tax_exempt: Yup.boolean().required().label('Tax exempt'),
				document_currency: Yup.string()
					.label('Document Currency')
					.matches(/^[a-zA-Z]*$/, 'Please enter valid Document Currency'),
				credit_period: Yup.number().min(1).max(999).label('credit period'),
				payment_tnc: Yup.string()
					.label('payment tnc')
					.matches(/^[a-zA-Z]*$/, 'Please enter valid payment tnc'),
				aadhar_number: Yup.string()
					.min(12)
					.max(12)
					.label('Aadhar number')
					.matches(/^[0-9]*$/, 'Please enter valid Aadhar number'),
				tan_number: Yup.string().min(10).max(10).label('TAN number'),
				cin_number: Yup.string().min(21).max(21).label('CIN number'),
				gst_number: Yup.string()
					.min(15)
					.max(15)
					.label('GST number')
					.when('gst_reg_type', (gst_reg_type, schema) => {
						if (gst_reg_type === 'registered') return schema.required();
						return schema;
					}),
				billing_info: Yup.array().of(
					Yup.object().shape({
						address: Yup.string()
							.required()
							.min(6)
							.max(200)
							.label('Address')
							.matches(/^[a-zA-Z0-9# ,-]*$/, 'Please enter valid address'),
						zone: Yup.string()
							.required()
							.min(4)
							.max(30)
							.label('Zone')
							.matches(/^[a-zA-Z ]*$/, 'Please enter valid zone'),
						state: Yup.string()
							.required()
							.min(3)
							.max(30)
							.label('State')
							.matches(/^[a-zA-Z ]*$/, 'Please enter valid state'),
						city: Yup.string()
							.required()
							.min(3)
							.max(30)
							.label('City')
							.matches(/^[a-zA-Z ]*$/, 'Please enter valid city'),
						pin_code: Yup.string()
							.required()
							.label('Pin Code')
							.min(6, pinError)
							.max(6, pinError)
							.matches(/^[0-9]*$/, 'Please enter valid pin code'),
					})
				),
				shipping_info: Yup.array().of(
					Yup.object().shape({
						address: Yup.string()
							.required()
							.min(6)
							.max(200)
							.label('Address')
							.matches(/^[a-zA-Z0-9# ,-]*$/, 'Please enter valid address'),
						zone: Yup.string()
							.required()
							.min(4)
							.max(30)
							.label('Zone')
							.matches(/^[a-zA-Z ]*$/, 'Please enter valid zone'),
						state: Yup.string()
							.required()
							.min(3)
							.max(30)
							.label('State')
							.matches(/^[a-zA-Z ]*$/, 'Please enter valid state'),
						city: Yup.string()
							.required()
							.min(3)
							.max(30)
							.label('City')
							.matches(/^[a-zA-Z ]*$/, 'Please enter valid city'),
						pin_code: Yup.string()
							.required()
							.label('Pin Code')
							.min(6, pinError)
							.max(6, pinError)
							.matches(/^[0-9]*$/, 'Please enter valid pin code'),
					})
				),
			}),
		[]
	);
	const getApprovalValue = (adhoc_approval_required) => {
		console.log(adhoc_approval_required);
		return adhoc_approval_required ? 'true' : 'false';
	};
	const initialValues = useMemo(
		() => ({
			adhoc_approval_required:
				getApprovalValue(formData?.adhoc_approval_required) || undefined,
			acc_number: formData?.banking_info?.acc_number || undefined,
			ifsc_code: formData?.banking_info?.ifsc_code || undefined,
			bank_name: formData?.banking_info?.bank_name || undefined,
			bank_city: formData?.banking_info?.bank_city || undefined,
			bank_doc: formData?.banking_info?.bank_doc || undefined,
			bank_branch: formData?.banking_info?.bank_branch || undefined,
			billing_info: getBillingPreFilledData(formData?.billing_info),
			shipping_info: getBillingPreFilledData(formData?.shipping_info),
			pan_number: formData?.document_info?.pan_number || undefined,
			gst_reg_type: formData?.document_info?.gst_reg_type || undefined,
			aadhar_number: formData?.document_info?.aadhar_number || undefined,
			gst_number: formData?.document_info?.gst_number || undefined,
			tan_number: formData?.document_info?.tan_number || undefined,
			cin_number: formData?.document_info?.cin_number || undefined,
			credit_amt: formData?.other_info?.credit_amt || undefined,
			tax_exempt: formData?.other_info?.tax_exempt || false,
			related_party: formData?.other_info?.related_party || false,
			black_listed: formData?.other_info?.black_listed || false,
			same_as_billing_loc: formData?.other_info?.same_as_billing_loc || false,
			document_currency: formData?.other_info?.document_currency || undefined,
			credit_period: formData?.other_info?.credit_period || undefined,
			payment_tnc: formData?.other_info?.payment_tnc || undefined,
		}),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[formData]
	);

	function addRemovePayment(arrayHelpers, index) {
		if (index === 0) {
			// arrayHelpers.insert(index + 1, getNewBillingRowData());
			arrayHelpers.push(getNewBillingRowData());
		} else {
			arrayHelpers.remove(index);
		}
	}

	function handlePicodeChange(e, index) {
		const pin_code = e?.target?.value;

		if (pin_code?.length === 6) {
			dispatch(getPincodeList(pin_code))
				.then((res) => {
					const { city, state, zone } = res?.rows?.[0] || {};
					if (ref?.current) {
						setLocationData(ref.current, index, city, state, zone);
					}
				})
				.catch((er) => {
					console.log('pincode error', er);
				});
		} else {
			console.log('not a valid pincode');
			if (ref?.current) {
				setLocationData(ref.current, index);
			}
		}
	}

	function setLocationData(
		refObject,
		index,
		city = undefined,
		state = undefined,
		zone = undefined
	) {
		refObject?.setFieldValue(`billing_info[${index}].city`, city);
		refObject?.setFieldValue(`billing_info[${index}].state`, state);
		refObject?.setFieldValue(`billing_info[${index}].zone`, zone);
	}

	function handleShipPicodeChange(e, index) {
		const pin_code = e?.target?.value;

		if (pin_code?.length === 6) {
			dispatch(getPincodeList(pin_code))
				.then((res) => {
					const { city, state, zone } = res?.rows?.[0] || {};
					if (ref?.current) {
						setShipLocationData(ref.current, index, city, state, zone);
					}
				})
				.catch((er) => {
					console.log('pincode error', er);
				});
		} else {
			console.log('not a valid pincode');
			if (ref?.current) {
				setShipLocationData(ref.current, index);
			}
		}
	}

	function setShipLocationData(
		refObject,
		index,
		city = undefined,
		state = undefined,
		zone = undefined
	) {
		refObject?.setFieldValue(`shipping_info[${index}].city`, city);
		refObject?.setFieldValue(`shipping_info[${index}].state`, state);
		refObject?.setFieldValue(`shipping_info[${index}].zone`, zone);
	}

	const handleSubmit = (values, { setErrors, setSubmitting }) => {
		console.log(values);
		const payload = {
			// eslint-disable-next-line no-unneeded-ternary
			adhoc_approval_required: values?.adhoc_approval_required === 'true' ? true : false,
			update_type: 'client',
			id: formData?.id,
			client_info: otherFormsData?.client_info,
			banking_info: {
				acc_number: values?.acc_number,
				bank_branch: values?.bank_branch,
				bank_city: values?.bank_city,
				bank_name: values?.bank_name,
				ifsc_code: values?.ifsc_code ? values?.ifsc_code.toUpperCase() : undefined,
				bank_doc: !isEmpty(bankFilesList)
					? bankFilesList
					: formData?.banking_info?.bank_doc,
			},
			billing_info: values?.billing_info,
			shipping_info: values?.shipping_info,
			document_info: {
				pan_number: values?.pan_number.toUpperCase(),
				gst_reg_type: values?.gst_reg_type,
				aadhar_number: values?.aadhar_number,
				gst_number: values?.gst_number,
				tan_number: values?.tan_number,
				cin_number: values?.cin_number,
				pan_doc: !isEmpty(panFilesList) ? panFilesList : formData?.document_info?.pan_doc,
				aadhar_doc: !isEmpty(aadharFilesList)
					? aadharFilesList
					: formData?.document_info?.aadhar_doc,
				gst_doc: !isEmpty(gstFilesList) ? gstFilesList : formData?.document_info?.gst_doc,
				tan_doc: !isEmpty(tanFilesList) ? tanFilesList : formData?.document_info?.tan_doc,
				cin_doc: !isEmpty(cinFilesList) ? cinFilesList : formData?.document_info?.cin_doc,
			},
			other_info: {
				credit_amt: Number(values?.credit_amt),
				tax_exempt: values?.tax_exempt,
				related_party: values?.related_party,
				black_listed: values?.black_listed,
				same_as_billing_loc: values?.same_as_billing_loc,
				document_currency: values?.document_currency,
				credit_period: values?.credit_period,
				payment_tnc: values?.payment_tnc,
			},
		};

		dispatch(
			updateClient({
				req_data: payload,
				setErrors,
			})
		)
			.then((res) => {
				console.log(res);
				navigate('/client-list');
				setSubmitting(false);
			})
			.catch(() => {
				setSubmitting(false);
			});
	};

	function handleFileUpload(files, key, setFieldValue) {
		formData.banking_info.bank_doc = files;
		setFieldValue('bank_doc', files);
		setBankFilesList(files);
	}

	const HeaderText = styled(Text)`
		color: #1890ff;
		font-size: 21px;
		background: #cccc;
		margin-top: 15px;
		padding: 10px;
	`;

	const ref = useRef(null);

	const BoxSpace = styled(Box)`
		padding: 16px;
		margin-top: 12px;
	`;

	const [panFilesList, setPanFilesList] = useState([]);
	const [aadharFilesList, setAadharFilesList] = useState([]);
	const [gstFilesList, setGstFilesList] = useState([]);
	const [tanFilesList, setTanFilesList] = useState([]);
	const [cinFilesList, setCinFilesList] = useState([]);
	const [bankFilesList, setBankFilesList] = useState([]);

	function handlePanFileUpload(files) {
		console.log('handlePanFileUpload', files);
		setPanFilesList(files);
	}
	function handleAadharFileUpload(files) {
		console.log('handleAadharFileUpload', files);
		setAadharFilesList(files);
	}
	function handleGstFileUpload(files) {
		console.log('handleGstFileUpload', files);
		setGstFilesList(files);
	}
	function handleTanFileUpload(files) {
		console.log('handleTanFileUpload', files);
		setTanFilesList(files);
	}
	function handleCinFileUpload(files) {
		setCinFilesList(files);
	}

	function handleGstType(e, setFieldValue) {
		if (e === 'unregistered') {
			setTimeout(() => {
				setFieldValue('gst_number', undefined);
			}, 200);
		}
	}
	function handleEdit() {
		console.log('before', editMode);
		setEditMode(!editMode);
		console.log('after', editMode);
	}
	function handleDeleteBankDoc(setFieldValue, values) {
		formData.banking_info.bank_doc = undefined;
		values.bank_doc = undefined;
		setFieldValue('bank_doc', undefined);
		setBankFilesList([]);
	}
	return (
		<Formik
			innerRef={ref}
			initialValues={initialValues}
			validationSchema={FormSchema}
			onSubmit={handleSubmit}
			enableReinitialize
		>
			{({ values, setFieldValue, errors }) => {
				console.log({ errors });
				console.log(values.shipping_info);
				console.log({ setFieldValue });

				return (
					<Box>
						<ACL action="update" module="client">
							{isEditMode && <EditModeBtn handleEdit={handleEdit} />}
						</ACL>
						<Form className={editMode === false ? 'disabled-div' : ''}>
							<HeaderText> Trip Details </HeaderText>
							<Box padding="1.5rem 2rem" background="#fff">
								<Row gutter={16} justify="space-between">
									<Col lg={12}>
										<FormInput
											name="adhoc_approval_required"
											label="Adhoc Approval Required  *"
										>
											<Select
												name="adhoc_approval_required"
												filterOption={(input, option) =>
													option.label
														.toLowerCase()
														.indexOf(input.toLowerCase()) >= 0
												}
												placeholder="Select"
												options={adhoc_approval_required_data}
											/>
										</FormInput>
									</Col>
									<Col lg={12}></Col>
								</Row>
							</Box>

							<HeaderText> Bank Details </HeaderText>
							<Box padding="1.5rem 2rem" background="#fff">
								<Row gutter={16} justify="space-between">
									<Col lg={12}>
										<FormInput name="acc_number" label="Account Number">
											<CustomInput name="acc_number" />
										</FormInput>
									</Col>
									<Col lg={12}>
										<FormInput name="ifsc_code" label="IFSC Code">
											<CustomInput name="ifsc_code" maxLength={11} />
										</FormInput>
									</Col>
								</Row>
								<Row gutter={16} justify="space-between">
									<Col lg={12}>
										<FormInput name="bank_name" label="Bank Name">
											<CustomInput name="bank_name" />
										</FormInput>
									</Col>
									<Col lg={12}>
										<FormInput name="bank_city" label="Bank City">
											<CustomInput name="bank_city" />
										</FormInput>
									</Col>
								</Row>
								<Row gutter={16} justify="space-between">
									<Col lg={12}>
										<FormInput name="bank_branch" label="Bank Branch">
											<CustomInput name="bank_branch" />
										</FormInput>
									</Col>
								</Row>
							</Box>
							<Box border="1px solid #ccc" padding="34px">
								<FilesUploadS3
									entity="client"
									key="bank_doc"
									setFunc={setFieldValue}
									successCallBack={handleFileUpload}
									name="Bank document"
									size={5120000}
									fileformates={pdfimgformates}
									filetypetoShow={pdfimgfiletypetoShow}
								/>
								<Box>
									{errors?.bank_doc && (
										<Box backgroundColor="#fff" color="red">
											Bank Document is required.
										</Box>
									)}
								</Box>
								<Box backgroundColor="#fff" textAlign="right" padding="1.5rem">
									{}
								</Box>
								{/* {filesList && (
									<ImageView
										entity="client"
										files={formData?.bank_doc}
										name="Bank Document"
									/>
								)} */}
								{isEditMode && values.bank_doc && (
									<ImageView
										entity="client"
										files={values.bank_doc}
										name="Bank Document"
									/>
								)}
								{(values?.bank_doc || formData?.bank_doc) && (
									<div style={{ marginTop: '10px' }}>
										<Button
											type="danger"
											icon={<DeleteOutlined />}
											onClick={() =>
												handleDeleteBankDoc(setFieldValue, values)
											}
										>
											Delete
										</Button>
									</div>
								)}
							</Box>
							<Box>
								<HeaderText> Billing Details </HeaderText>
								<FieldArray
									name="billing_info"
									render={(arrayHelpers) => (
										<div>
											{values?.billing_info?.map((rowData, index) => (
												<BoxSpace key={rowData?.id}>
													<Row gutter={16} justify="end">
														{index > 0 && (
															<CancelButton
																onClick={() =>
																	addRemovePayment(
																		arrayHelpers,
																		index
																	)
																}
																type="button"
																icon={<PoweroffOutlined />}
															>
																{index === 0
																	? 'Add more Billing Address'
																	: 'Remove'}
															</CancelButton>
														)}
													</Row>
													<Row gutter={16} justify="space-between">
														<Col lg={12}>
															<FormInput
																name={`billing_info[${index}].address`}
																label="Address *"
															>
																<CustomInput
																	name={`billing_info[${index}].address`}
																/>
															</FormInput>
														</Col>
														<Col lg={12}>
															<FormInput
																name={`billing_info[${index}].pin_code`}
																label="Pin Code *"
																onChange={(e) =>
																	handlePicodeChange(e, index)
																}
															>
																<CustomInput
																	name={`billing_info[${index}].pin_code`}
																	maxLength={6}
																/>
															</FormInput>
														</Col>
													</Row>
													<Row gutter={16} justify="space-between">
														<Col lg={12}>
															<FormInput
																name={`billing_info[${index}].zone`}
																label="Zone *"
															>
																<CustomInput
																	name={`billing_info[${index}].zone`}
																	disabled
																/>
															</FormInput>
														</Col>
														<Col lg={12}>
															<FormInput
																name={`billing_info[${index}].state`}
																label="State *"
															>
																<CustomInput
																	name={`billing_info[${index}].state`}
																	disabled
																/>
															</FormInput>
														</Col>
													</Row>
													<Row gutter={16} justify="space-between">
														<Col lg={12}>
															<FormInput
																name={`billing_info[${index}].city`}
																label="City *"
															>
																<CustomInput
																	name={`billing_info[${index}].city`}
																	disabled
																/>
															</FormInput>
														</Col>
														<Col lg={12}></Col>
													</Row>
													<Row gutter={16} justify="space-between">
														<Col span={4}>
															{index === 0 && (
																<ActionAddButton
																	type="primary"
																	onClick={() =>
																		addRemovePayment(
																			arrayHelpers,
																			index
																		)
																	}
																	icon={<PoweroffOutlined />}
																>
																	{index === 0
																		? '+ Add more Billing Address'
																		: 'Remove'}
																</ActionAddButton>
															)}
														</Col>
													</Row>
												</BoxSpace>
											))}
										</div>
									)}
								/>
							</Box>
							<Box>
								<HeaderText> Shipping Details </HeaderText>
								<FieldArray
									name="shipping_info"
									render={(arrayHelpers) => (
										<div>
											{values?.shipping_info?.map((rowData, index) => (
												<BoxSpace key={rowData?.id}>
													<Row gutter={16} justify="end">
														{index > 0 && (
															<CancelButton
																onClick={() =>
																	addRemovePayment(
																		arrayHelpers,
																		index
																	)
																}
																type="button"
																icon={<PoweroffOutlined />}
															>
																{index === 0
																	? 'Add more Shipping Address'
																	: 'Remove'}
															</CancelButton>
														)}
													</Row>
													<Row gutter={16} justify="space-between">
														<Col lg={12}>
															<FormInput
																name={`shipping_info[${index}].address`}
																label="Address *"
															>
																<CustomInput
																	name={`shipping_info[${index}].address`}
																/>
															</FormInput>
														</Col>
														<Col lg={12}>
															<FormInput
																name={`shipping_info[${index}].pin_code`}
																label="Pin Code *"
																onChange={(e) =>
																	handleShipPicodeChange(e, index)
																}
															>
																<CustomInput
																	name={`shipping_info[${index}].pin_code`}
																	maxLength={6}
																/>
															</FormInput>
														</Col>
													</Row>
													<Row gutter={16} justify="space-between">
														<Col lg={12}>
															<FormInput
																name={`shipping_info[${index}].zone`}
																label="Zone *"
															>
																<CustomInput
																	name={`shipping_info[${index}].zone`}
																	disabled
																/>
															</FormInput>
														</Col>
														<Col lg={12}>
															<FormInput
																name={`shipping_info[${index}].state`}
																label="State *"
															>
																<CustomInput
																	name={`shipping_info[${index}].state`}
																	disabled
																/>
															</FormInput>
														</Col>
													</Row>
													<Row gutter={16} justify="space-between">
														<Col lg={12}>
															<FormInput
																name={`shipping_info[${index}].city`}
																label="City *"
															>
																<CustomInput
																	name={`shipping_info[${index}].city`}
																	disabled
																/>
															</FormInput>
														</Col>
														<Col lg={12}></Col>
													</Row>
													<Row gutter={16} justify="space-between">
														<Col span={4}>
															{index === 0 && (
																<ActionAddButton
																	type="primary"
																	onClick={() =>
																		addRemovePayment(
																			arrayHelpers,
																			index
																		)
																	}
																	icon={<PoweroffOutlined />}
																>
																	{index === 0
																		? '+ Add more Shipping Address'
																		: 'Remove'}
																</ActionAddButton>
															)}
														</Col>
													</Row>
												</BoxSpace>
											))}
										</div>
									)}
								/>
							</Box>
							<Box>
								<HeaderText> Document Details </HeaderText>
								<Box padding="1.5rem 2rem" background="#fff">
									<Row gutter={16} justify="space-between">
										<Col lg={12}>
											<FormInput name="pan_number" label="PAN Number *">
												<CustomInput name="pan_number" />
											</FormInput>
										</Col>
										<Col lg={12}>
											<FormInput name="gst_reg_type" label="GST reg type *">
												<Select
													name="gst_reg_type"
													filterOption={(input, option) =>
														option.label
															.toLowerCase()
															.indexOf(input.toLowerCase()) >= 0
													}
													onChange={(e) =>
														handleGstType(e, setFieldValue)
													}
													placeholder="Select"
													options={gstRegType}
												/>
											</FormInput>
										</Col>
									</Row>
									<Row gutter={16} justify="space-between">
										<Col lg={12}>
											<FormInput name="aadhar_number" label="Aadhar Number">
												<CustomInput name="aadhar_number" />
											</FormInput>
										</Col>
										<Col lg={12}>
											<FormInput name="gst_number" label="GST Number">
												<CustomInput
													disabled={
														values?.gst_reg_type === 'unregistered' ||
														values?.gst_reg_type === undefined
													}
													name="gst_number"
												/>
											</FormInput>
										</Col>
										<Col lg={12}>
											<FormInput name="tan_number" label="TAN Number">
												<CustomInput name="tan_number" />
											</FormInput>
										</Col>
										<Col lg={12}>
											<FormInput name="cin_number" label="CIN Number">
												<CustomInput name="cin_number" />
											</FormInput>
										</Col>
									</Row>
								</Box>
								<Box border="1px solid #ccc" padding="34px">
									<FilesUploadS3
										entity="client"
										successCallBack={handlePanFileUpload}
										name="PAN document"
										size={5120000}
										fileformates={pdfimgformates}
										filetypetoShow={pdfimgfiletypetoShow}
									/>
									<Box backgroundColor="#fff" textAlign="right" padding="1.5rem">
										{}
									</Box>
									{/* {panFilesList && (
										<ImageView
											entity="client"
											files={formData?.pan_doc}
											name="PAN Document"
										/>
									)} */}
									{isEditMode && (
										<ImageView
											entity="client"
											files={formData?.document_info?.pan_doc}
											name="PAN Document"
										/>
									)}
								</Box>
								<BoxMod></BoxMod>
								<Box border="1px solid #ccc" padding="34px">
									<FilesUploadS3
										entity="client"
										successCallBack={handleAadharFileUpload}
										name="Aadhar document"
										size={5120000}
										fileformates={pdfimgformates}
										filetypetoShow={pdfimgfiletypetoShow}
									/>
									<Box backgroundColor="#fff" textAlign="right" padding="1.5rem">
										{}
									</Box>
									{/* {aadharFilesList && (
										<ImageView
											entity="client"
											files={formData?.aadhar_doc}
											name="AAdhar Document"
										/>
									)} */}
									{isEditMode && (
										<ImageView
											entity="client"
											files={formData?.document_info?.aadhar_doc}
											name="PAN Document"
										/>
									)}
								</Box>
								<Box border="1px solid #ccc" padding="34px">
									<FilesUploadS3
										entity="client"
										successCallBack={handleGstFileUpload}
										name="GST document"
										size={5120000}
										fileformates={pdfimgformates}
										filetypetoShow={pdfimgfiletypetoShow}
									/>
									<Box backgroundColor="#fff" textAlign="right" padding="1.5rem">
										{}
									</Box>
									{isEditMode && (
										<ImageView
											entity="client"
											files={formData?.document_info?.gst_doc}
											name="GST Document"
										/>
									)}
								</Box>
								<Box border="1px solid #ccc" padding="34px">
									<FilesUploadS3
										entity="client"
										successCallBack={handleTanFileUpload}
										name="TAN document"
										size={5120000}
										fileformates={pdfimgformates}
										filetypetoShow={pdfimgfiletypetoShow}
									/>
									<Box backgroundColor="#fff" textAlign="right" padding="1.5rem">
										{}
									</Box>
									{/* {gstFilesList && (
										<ImageView
											entity="client"
											files={formData?.gst_doc}
											name="GST Document"
										/>
									)} */}
									{isEditMode && (
										<ImageView
											entity="client"
											files={formData?.document_info?.tan_doc}
											name="TAN Document"
										/>
									)}
								</Box>
								<Box border="1px solid #ccc" padding="34px">
									<FilesUploadS3
										entity="client"
										successCallBack={handleCinFileUpload}
										name="CIN document"
										size={5120000}
										fileformates={pdfimgformates}
										filetypetoShow={pdfimgfiletypetoShow}
									/>
									<Box backgroundColor="#fff" textAlign="right" padding="1.5rem">
										{}
									</Box>
									{/* {gstFilesList && (
										<ImageView
											entity="client"
											files={formData?.gst_doc}
											name="GST Document"
										/>
									)} */}
									{isEditMode && (
										<ImageView
											entity="client"
											files={formData?.document_info?.cin_doc}
											name="CIN Document"
										/>
									)}
								</Box>
							</Box>
							<HeaderText> Other Details </HeaderText>
							<Box padding="1.5rem 2rem" background="#fff">
								<Row gutter={16} justify="space-between">
									<Col lg={12}>
										<FormInput name="related_party" label="Related Party">
											<Radio.Group
												name="related_party"
												defaultValue={values?.tax_exempt}
											>
												<Radio value>Yes</Radio>
												<Radio value={false}>No</Radio>
											</Radio.Group>
										</FormInput>
									</Col>
									<Col lg={12}>
										<FormInput
											name="same_as_billing_loc"
											label="Same as Billing Loc"
										>
											<Radio.Group
												name="same_as_billing_loc"
												defaultValue={values?.same_as_billing_loc}
											>
												<Radio value>Yes</Radio>
												<Radio value={false}>No</Radio>
											</Radio.Group>
										</FormInput>
									</Col>
								</Row>
								<Row gutter={16} justify="space-between">
									<Col lg={12}>
										<FormInput name="tax_exempt" label="Tax Exempt *">
											<Radio.Group
												name="tax_exempt"
												defaultValue={values?.tax_exempt}
											>
												<Radio value>Yes</Radio>
												<Radio value={false}>No</Radio>
											</Radio.Group>
										</FormInput>
									</Col>
									<Col lg={12}>
										<FormInput name="black_listed" label="Black listed">
											<Radio.Group
												name="black_listed"
												defaultValue={values?.black_listed}
											>
												<Radio value>Yes</Radio>
												<Radio value={false}>No</Radio>
											</Radio.Group>
										</FormInput>
									</Col>
								</Row>
								<Row gutter={16} justify="space-between">
									<Col lg={12}>
										<FormInput name="credit_amt" label="Credit amount">
											<CustomInput name="credit_amt" type="number" />
										</FormInput>
									</Col>
									<Col lg={12}>
										<FormInput
											name="document_currency"
											label="Document Currency"
										>
											<CustomInput name="document_currency" />
										</FormInput>
									</Col>
								</Row>
								<Row gutter={16} justify="space-between">
									<Col lg={12}>
										<FormInput name="credit_period" label="Credit Period">
											<CustomInput name="credit_period" type="number" />
										</FormInput>
									</Col>
									<Col lg={12}>
										<FormInput name="payment_tnc" label="Payment tnc">
											<CustomInput name="payment_tnc" />
										</FormInput>
									</Col>
								</Row>
							</Box>
							<Box backgroundColor="#f5f5f5" textAlign="right" padding="1.5rem">
								<CancelButton
									onClick={() => navigate('/client-list')}
									type="button"
								>
									Cancel
								</CancelButton>
								<Button borderRadius="4px" backgroundColor="#18405d" type="submit">
									{isEditMode ? 'Update' : 'Submit'}
								</Button>
							</Box>
							<Debug />
						</Form>
					</Box>
				);
			}}
		</Formik>
	);
}

ClientAllSectionForm.propTypes = {
	isEditMode: PropTypes.bool,
	formData: PropTypes.object,
	otherFormsData: PropTypes.object,
};
